<template>
    <div v-if="isNote" class="order_content__info_item" :class="classItem">
        <div class="order_content__info_item_main_note">
            {{ note }}
        </div>
    </div>
    <div v-else class="order_content__info_item" :class="classItem">
        <div class="order_content__info_item_main">
            <div class="order_content__info_item_main_wrapper">
                <div class="order_content__info_item_main_name">
                    {{ nameItem }}
                </div>
                <div v-if="isDiscountPercent" class="order_content__info_item_main_discount_percent">
                    {{ discountPercent }}
                </div>
            </div>
            <div v-if="isDiscountSum" class="order_content__info_item_main_discount_sum">
                {{ discountSum }}
            </div>
        </div>
        <div v-if="isSumItem" class="order_content__info_item_price">
            {{ sumItem }}
        </div>
    </div>

</template>

<script>

export default {
    name: "order_content_info_item_props",
    props: {
        isTotal: {
            type: Boolean,
            required: true,
        },
        note: {
            type: String,
            required: true,
        },
        nameItem: {
            type: String,
            required: true,
        },
        discountPercent: {
            type: String,
            required: true,
        },
        discountSum: {
            type: String,
            required: true,
        },
        sumItem: {
            type: String,
            required: true,
        },
    },
    emits: [],
    components: {},
    data() {
        return {
        }
    },
    methods: {
    },
    computed: {
        classItem() {
            return {
                'total': this.isTotal,
            }
        },
        isNote() {
            return this.note !== '';
        },
        isDiscountPercent() {
            return this.discountPercent !== '';
        },
        isDiscountSum() {
            return this.discountSum !== '';
        },
        isSumItem() {
            return this.sumItem !== '';
        },
    },
}
</script>
